import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import AgeGate from "@/components/AgeGate";
import Header from "@/components/Header";
import CartDrawer from "@/components/CartDrawer";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import PriceList from "@/pages/PriceList";
import Admin from "@/pages/Admin";
import PolicyPage from "@/pages/PolicyPage";
import Checkout from "@/pages/Checkout";
import HowFound from "@/pages/HowFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, lerp: 0.09 });
    window.__lenis = lenis;
    return () => lenis.destroy();
  }, []);

  return (
    <CartProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="noise-overlay" aria-hidden="true" />
        <AgeGate />
        <Header />
        <div className="app-shell text-[#F9F6F0]">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:id" element={<ProductDetail />} />
            <Route path="/pricing" element={<PriceList />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/terms" element={<PolicyPage type="terms" />} />
            <Route path="/privacy" element={<PolicyPage type="privacy" />} />
            <Route path="/shipping" element={<PolicyPage type="shipping" />} />
            <Route path="/refunds" element={<PolicyPage type="refunds" />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/how-did-you-find-us" element={<HowFound />} />
          </Routes>
          <Footer />
        </div>
        <CartDrawer />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#111111",
              border: "1px solid rgba(255,255,255,0.12)",
              color: "#F9F6F0",
              borderRadius: "0px",
            },
          }}
        />
      </BrowserRouter>
    </CartProvider>
  );
}
